// is_under_test set to true when running automated tests
export const isUnderTest = () => {
  const isUnderTest = typeof window !== 'undefined' && localStorage.getItem('is_under_test')
  return isUnderTest === 'true'
}
